<template>
    <PopoverRight ref="popoverMenu" width="550px" >
        <div class="popover-slider-bar">
            <h1 class="bar-title">用户编辑</h1>
            <el-form class="form-container" :model="userInfo" :rules="userRules" ref="userInfoForm">
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">姓名</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item ">
                        <el-form-item label="" prop="name">
                            <el-input placeholder="请输入姓名"  v-model="userInfo.name">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">用户名</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item ">
                        <el-form-item label="" prop="account">
                            <el-input placeholder="请输入用户名"  v-model="userInfo.account">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <p class="remark">注:用户将使用该用户名登录系统</p>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">密码</span>
                    </div>
                    <div class="form-input-item ">
                        <el-form-item label="" prop="password">
                            <el-input placeholder="请输入密码"  v-model="userInfo.password" type="password">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">确认密码</span>
                    </div>
                    <div class="form-input-item ">
                        <el-form-item label="" prop="password_confirm">
                            <el-input placeholder="请输入密码"  v-model="userInfo.password_confirm" type="password">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">是否启用</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item ">
                        <el-form-item label="" prop="status">
                            <el-switch active-color="#13ce66" v-model="userInfo.status" active-value='0' inactive-value='1'></el-switch>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-button">
                    <el-button type="primary" @click="submitForm('userInfoForm')">确 认</el-button>
                    <el-button type="info" plain @click.stop.prevent="hide">取 消</el-button>
                </div>
            </el-form>
        </div>
    </PopoverRight>
</template>

<script>
    import PopoverRight from '@/components/popoverRight/index'
    import { modifyAdmin } from '@/service/user'
    import {validatePassword} from '@/utils/validate'
    import {validateChat} from '@/utils/validate'
    export default {
        name: "edit",
        components: {
            PopoverRight
        },
        props: {
            callback: Function
        },
        data () {
            let validPasswordConfirm = (rule,value,callback) => {
                if (value != this.userInfo.password) {
                    callback(new Error("确认密码与密码不一致"))
                } else {
                    callback()
                }
            }
            return {
                userInfo: {
                    id : 0,
                    status : 0,
                    name: '',
                    account: '',
                    password: '',
                    password_confirm: '',
                },
                userRules: {
                    name: [
                        { required: true, message: '请填写名称', trigger: 'blur' },
                        { min: 2, max: 25, message: '请输入2-25个字符的姓名', trigger: 'blur' },
                        {validator:validateChat,type:4, trigger: 'blur',result:'姓名'}
                    ],
                    password : [
                        { validator: validatePassword, result: '密码',trigger: 'blur', isEmpty: true }
                    ],
                    password_confirm : [
                        { validator:validPasswordConfirm, trigger: 'blur' }
                    ],
                },
            }
        },
        methods : {
            async open () {
                this.$refs.popoverMenu && this.$refs.popoverMenu.open()
            },
            /** 关闭右侧悬浮层 */
            hide () {
                this.resetForm();
                this.$refs.popoverMenu && this.$refs.popoverMenu.hide()
                this.$refs.userInfoForm && this.$refs.userInfoForm.clearValidate()
            },
            resetForm () {
                this.userInfo = {
                    id : 0,
                    status : 0,
                    name: '',
                    account: '',
                    password: '',
                    password_confirm: '',
                }
            },
            submitForm (formName) {
                this.$refs[formName].validate(async (valid) => {
                    if (valid) {
                        let query = {
                            status : this.userInfo.status,
                            name : this.userInfo.name,
                            role_id : this.userInfo.role_id,
                            account:this.userInfo.account
                        }
                        if (this.userInfo.password.length > 0) {
                            query.password = this.userInfo.password
                            query.password2 = this.userInfo.password
                        }
                        modifyAdmin(this.userInfo.id, query).then((data) => {
                            this.$message({
                                message: '修改成功',
                                type: 'success',
                                duration: 3 * 1000
                            })
                            this.resetForm()
                            this.hide()
                            this.callback && this.callback()
                        }).catch(err => {
                            const message = err.context ? err.context[0] : err.message
                            this.$message({
                                message: message || '修改失败',
                                type: 'error',
                                duration: 3 * 1000
                            })
                        })

                    } else {
                        return false
                    }
                })
            },
        },
    }
</script>

<style scoped>

</style>
